<template>
  <div class="wechat" :style="{height:show ? 22+(openlist.length+1)*40+'px' : 0,opacity:show ? 1 : 0,paddingTop:show ? 27+'px' : 0,overflow:show ? 'auto': 'hidden'}">
    <div class="wechat-angle bg-white"></div>
    <div class="wechat-list flex-vc bg-white">
      <div class="wechat-single font-size14 black-font font-more" v-for="(item,index) in openlist" @click="upload(item.authorizer_appid)" style="display: block;text-align: center;line-height: 40px;">{{item.nick_name}}</div>
      <!-- <div class="wechat-single font-size14 black-font font-more" v-for="(item,index) in openlist" @click="upload(item.authorizer_appid)" style="display: block;text-align: center;line-height: 40px;">哈哈哈哈哈哈哈哈哈哈哈</div> -->
    <router-link class="wechat-single flex-cm font-size14 black-font" :to="{path:'/home/setting'}" tag="div">绑定公众号</router-link>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'wechat',
    props:{
      show:{
        type:Boolean,
        value:true
      },
      id:String,
      uploadtype:{
        type:Number,
        value:1
      },
    },
    data () {
      return {
        openid:JSON.parse(localStorage.getItem('userinfo')).openid,
        openlist:[]
      }
    },
    watch: {
      id(val, oldVal) {
          console.log("inputVal = " + val + " , oldValue = " + oldVal)
          this.id=val;
      },
      uploadtype(val,oldVal){
          this.uploadtype=val;
      },
    },
    methods:{
      upload(appid){
        console.log(this.id)
        if(this.id==''){
            this.$message({
                showClose: true,
                message: '请选择投稿'
            });
        }else{
          if(this.id.indexOf(',')==-1){
            this.upwechat(appid);
          }else{
            let idarr=this.id.split(',');
            if(idarr.length>5){
                this.$message({
                    showClose: true,
                    message: '单次上传最多不能超过5个投稿'
                });
            }else{
                this.upwechat(appid);
            }
          }
        }

      },
      upwechat(appid){
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          text:'正在上传',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$http({
          url:'https://pfotoo.com?s=App.Open.UploadFile'+this.$getsign(),
          params:{
            authorizer_appid:appid,
            type:this.uploadtype,
            id:this.id,
          },
          method:'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res)=>{
          console.log(res.body)
          let json=res.body;
          if(res.body.ret==200){
             loading.close();
             this.$message({
                 message: '所选作品已上传至公众号',
                 type: 'success'
             });
          }
        })
      },
      getopenlist(){
       this.$http({
         url:'https://pfotoo.com?s=App.User.GetAuthorizerByopenid'+this.$getsign(),
         params:{
           openid:this.openid
         },
         method:'POST',
         headers: {
           'Content-Type': 'application/x-www-form-urlencoded'
         }
       }).then((res)=>{
         console.log(res.body,'rrrrrr')
         let json=res.body;
         if(res.body.ret==200){
           console.log(json)
           if(JSON.stringify(json.data)!="{}"){
             this.openlist=json.data;
           }
         }
       })
      },
    },
    mounted(){
      console.log('fdsffsgggdvcvcc')
      this.getopenlist();
    }
  }
</script>

<style>
  .wechat{
    width:120px;
    height:0;
    position: absolute;
    left:0px;
    right:0px;
    top:32px;
    margin: 0 auto;
    border-radius:3px;
    transition: height ease .3s,opacity ease .2s 0.1s;
    opacity: 0;
  }
  .wechat-angle{
      width: 10px;
      height: 10px;
      -webkit-transform: rotate(-45deg);
      transform: rotate(-45deg);
      position: absolute;
      top: 22px;
      left: 0;
      right: 0;
      margin: 0 auto;
      /* -webkit-box-shadow: 0 0 4px 1px rgba(0,0,0,.1);
      box-shadow: 0 0 4px 1px rgba(0,0,0,.1); */
      z-index: 11;
      border-right: 1px solid rgba(0,0,0,.1);
      border-top: 1px solid rgba(0,0,0,.1);
  }
  .wechat-list{
    width: 100%;
    position: relative;
    z-index:2;
    /* -webkit-box-shadow: 0 0 6px rgba(0,0,0,.1);
    box-shadow: 0 0 6px rgba(0,0,0,.1); */
    border: 1px solid rgba(0,0,0,.1);
    box-sizing: border-box;
  }
  .wechat-single{
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #EEF2F2;
    box-sizing: border-box;
    padding: 0  5px;
  }
  .wechat-single:last-child{
    border-bottom: 0;
  }
  .wechat-single:hover{
    color: #3DC4A7;
  }
</style>



// WEBPACK FOOTER //
// src/components/wechat.vue